<template>
  <div style="padding: 16px">
    <h3>平台内容关键词检测已升级为智能监测系统</h3>
    <p>
      <strong>1. 智能标记分级：</strong>
      违规关键词可自动收集和更新，如危害国家安全、散布影响国家和谐、动态引战、谣言等内容关键词。
    </p>
    <p>
      <strong>2. 违规智能监测：</strong>
      用户在平台上发布的动态、评论、会议活动等内容，平台通过智能监测系统，能够及时发现并标记涉及违规内容，同时会给到告知提示。
    </p>
    <br />
    <div style="width: 520px; padding: 16px; background: #666; color: #fff; border-radius: 8px; line-height: 1.6">
      <pre style="margin: 0">
{
  "高危": ["台独", "中共", "法轮功", "色情"],
  "敏感": ["霸凌", "欺凌"],
  "一般": ["地域歧视", "种族歧视", "宗教攻击"]
}</pre
      >
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
  h3,
  strong {
    color: #255fac;
  }
</style>
